<script setup lang="ts">
const { isSubmitting } = defineProps<{
  isSubmitting: boolean
  label?: string
}>()
</script>

<template>
  <BaseButton
    type="submit"
    color="primary"
    flavor="solid"
    :loading="isSubmitting"
    :disabled="isSubmitting"
  >
    <slot>{{ label || $t('submit') }}</slot>
  </BaseButton>
</template>
